module.exports = __webpack_public_path__ + "static/media/zappertak-logo.3afe7cbf.png";